import React, { useEffect, useState } from 'react';
import HandleList from './components/HandleList';
import UnitContainer from './components/UnitContainer';
import FlowContainer from './components/FlowContainer';
import RightClick from './components/RightClick';
import useFlowSyncInit from './hook/useFlowSyncInit';
import { useProjectState } from '@starflow/app/store';
import useCalcFlowContainerHeght from './hook/useCalcFlowContainerHeght';

export const resizeContainerId = 'flow-resize-container';
let flag = false;
export const FlowWrapper = React.memo(() => {
  const isFoldFlow = useProjectState('isFoldFlow');
  const flows = useProjectState('flows');
  const [defH, setDefH] = useState(26); // flow区域默认高度
  useFlowSyncInit();
  useCalcFlowContainerHeght(isFoldFlow, defH);
  useEffect(() => {
    if (flows?.length > 0 && !flag) {
      flag = true;
      setDefH(162);
    }
  }, [flows?.length]);
  if (isFoldFlow) {
    return null;
  }
  return (
    <div className={`h-[${defH}px] bg-white text-[12px]`} id={resizeContainerId}>
      <HandleList defH={defH} />
      <UnitContainer />
      <FlowContainer />
      <RightClick />
    </div>
  );
});
